import { i18nTranslate } from 'src/utils'
const usersData = [
  {
    id: 332,
    teamId: 301,
    buyerInfo: {
      collectionId: 16,
      dateOfBirth: '',
      email: '',
      firstName: '',
      gender: 'male',
      guest: false,
      id: 2531,
      lastName: '',
      phoneNumber: '',
      userName: '',
      photo: '',
      status: 'ACTIVE',
      type: 1,
    },
    accountId: 297,
  },
  {
    id: 333,
    teamId: 302,
    buyerInfo: {
      collectionId: 16,
      dateOfBirth: '',
      email: '',
      firstName: '',
      gender: 'male',
      guest: false,
      id: 2532,
      lastName: '',
      phoneNumber: '1234567899',
      userName: '',
      photo: 'string_url',
      status: 'ACTIVE',
      type: 1,
    },
    accountId: 297,
  },
]
const teams = [
  {
    id: 301,
    accountId: 1,
    costCentreId: 1,
    name: 'NUTS',
    description: 'NUTS',
    status: 'active',
    teamBuyer: [
      {
        id: 1,
        userId: '1',
        teamId: 1,
        accountId: 1,
      },
    ],
  },
  {
    id: 302,
    accountId: 2,
    costCentreId: 2,
    name: 'BOLTS',
    description: 'BOLTS',
    status: 'active',
    teamBuyer: [
      {
        id: 2,
        userId: '2',
        teamId: 2,
        accountId: 2,
      },
    ],
  },
  {
    id: 303,
    accountId: 3,
    costCentreId: 3,
    name: 'CREWS',
    description: 'CREWS',
    status: 'active',
    teamBuyer: [
      {
        id: 3,
        userId: '3',
        teamId: 3,
        accountId: 3,
      },
    ],
  },
]
const activeTitle = i18nTranslate('status.active', 'Active')
const invitedTitle = i18nTranslate('status.invited', 'Invited')
const statuses = [
  { label: activeTitle, value: 'ACTIVE' },
  { label: invitedTitle, value: 'NOTACTIVATED' },
]
const dummyEmailRegex = /@noemail/
const roles = [i18nTranslate('user.userLabel', 'User')]
export { usersData, teams, statuses, roles, dummyEmailRegex }
